import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex mt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://login.jtel.in/"
}, "My Account", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_jt_support_form = _resolveComponent("jt-support-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { class: "top-bar" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "iso-certified mb-n1 mr-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "py-0 mb-1",
                  cols: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: require('../../assets/logo.jpg'),
                          height: "90",
                          class: "logo-size"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "10",
                  class: "d-flex flex-row-reverse menu-text"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_router_link, { to: "/" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Home")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-3 mt-n1",
                          inset: "",
                          vertical: "",
                          style: {"height":"25px"}
                        }),
                        _createElementVNode("span", {
                          style: {"cursor":"pointer"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showSupport=true))
                        }, "Support"),
                        _createVNode(_component_v_divider, {
                          class: "mx-3 mt-n1",
                          inset: "",
                          vertical: "",
                          style: {"height":"25px"}
                        }),
                        _hoisted_2
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: $setup.showSupport,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showSupport) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_jt_support_form, {
          onClosePopup: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeBookNow()))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}